import gql from 'graphql-tag';

export const DeleteDispatchIssueDocument = gql`
  mutation DeleteDispatchIssueDocumentBulk($input: DeleteDispatchIssueDocumentBulkInput!) {
    deleteDispatchIssueDocumentBulk(input: $input) {
      deleted
    }
  }
`;
